export const permanent = (store) => {
	let savedState = null;
	try {
		savedState = localStorage.getItem("HKStore");
	} catch (error) {
		throw error;
	}
	if (savedState) {
		store.replaceState(Object.assign({}, store.state, JSON.parse(savedState)));
	}
	store.subscribe((mutation, state) => {
		const saveState = {
			...state,
		};
		try {
			localStorage.setItem("HKStore", JSON.stringify(saveState));
		} catch (error) {
			throw error;
		}
	});
};
